import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose, AiOutlineSearch } from "react-icons/ai";
import emptyList from "../../utils/emptyList.png";
// import noImage from "../utils/noImage.jpg";
import notAllowedSymbol from "../../utils/notAllowedSymbol.svg";
import ImageIcon from "../../utils/imageIcon.png";
import Tooltip from "@mui/material/Tooltip";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ProductCreation from "../../components/lead_and_quotation/ProductCreation";
import { Modal } from "@mui/material";
import { CiEdit } from "react-icons/ci";
import ProductCreationEdit from "./ProductCreationEdit";
import CircularProgress from "@mui/material/CircularProgress";
import ProductCreationForm from "../../components/lead_and_quotation/ProductCreation";

const StockList = () => {
  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  let timerObject = useRef();

  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const userFromUserObjectInLocalStorage = currentUserObject[0].user?.trim();

  const [loadingitems, setLoadingitems] = useState(false);

  const [currentItemToEdit, setCurrentItemToEdit] = useState(null);
  const [showHideEditProductPopup, setShowHideEditProductPopup] =
    useState(false);
  const [itemCodeAlreadyPresentInDb, setItemCodeAlreadyPresentInDb] =
    useState(false);

  const [unitList, setUnitList] = useState(null);
  const [groupList, setGroupList] = useState(null);
  const [subGroupList, setSubGroupList] = useState(null);
  const [categoryList, setCategoryList] = useState(null);
  const [subCategoryList, setSubCategoryList] = useState(null);
  const [duplicateItemCodeArray, setDuplicateItemCodeArray] = useState(null)
 
  const getUnit = () => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/mastercount/${company_code_from_local_storage}/unit/-/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        setUnitList(res.data);
      })
      .catch((err) => {});
  };
  const getGroup = () => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/mastercount/${company_code_from_local_storage}/group/-/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        setGroupList(res.data);
      })
      .catch((err) => {});
  };

  const getSubGroup = () => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/mastercount/${company_code_from_local_storage}/subgroup/-/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        setSubGroupList(res.data);
      })
      .catch((err) => {});
  };

  const getCategory = () => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/mastercount/${company_code_from_local_storage}/category/-/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        setCategoryList(res.data);
      })
      .catch((err) => {});
  };

  const getSubCategory = () => {
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/mastercount/${company_code_from_local_storage}/subcategory/-/-`;

    axios
      .get(apiUrl)
      .then((res) => {
        setSubCategoryList(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getUnit();
    getGroup();
    getSubGroup();
    getCategory();
    getSubCategory();
  }, []);

  const initialObjectToSendAPI = {
    code: "",
    oem: "",
    model_no: "",
    description: "",
    specification: "",
    group: "",
    sub_group: "",
    category: "",
    sub_category: "",
    volume: "",
    weight: "",
    hscode: "",
    origin: "",
    class: "",
    unit: "",
    weblink: "",
    op_qty: "0",
    bal_qty: "",
    cash_price: "0",
    credit_price: "0",
    spl_price: "",
    block_price: "0",
    cost_open: "0",
    cost_unit: "0",
    cost_avg: "0",
    last_pcost: "",
    dcp: "",
    min_qty: "",
    reorder_qty: "0",
    fixed_cost: "",
    message: "",
    message_2: "",
    product_type: "service", // or service
    location: "",
    store_no: "",
  };

  const [objectToSendToState, setObjectToSendToState] = useState(
    initialObjectToSendAPI
  );

  const [showHidePopup, setShowHidePopup] = useState(false);

  const [isCallingSeachApi, setIsCallingSeachApi] = useState(false);

  const [stockListData, setStockListData] = useState(null);
  const [searchItem, setSearchItem] = useState("");
  const [searchResultData, setSearchResultData] = useState(null);
  const [showDropdown, setShowDropdown] = useState(null);
  const [selectedStockItem, setSelectedStockItem] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [openTooltipIndex, setOpenTooltipIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openItemCodeIndex, setOpenItemCodeIndex] = useState(null);
  const [image, setImage] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenProductCreation, setIsModalOpenProductCreation] =
    useState(false);
  const [isImageExistingModalOpen, setIsImageExistingModalOpen] =
    useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [selctedImageItemCode, setSelctedImageItemCode] = useState(null);
  const [existingItemImage, setExistingItemImage] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    fetchStockList();
  }, []);

  useEffect(() => {
    setTableData(searchResultData || []);
  }, [searchResultData]);

  // console.log("image", image);
  const fetchStockList = async () => {
    setLoadingitems(true);

    const response = await axios.get(
      `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/Sitem50/12345`
    );
    const data = response.data;

    setLoadingitems(false);

    // console.log("data:", data);
    setStockListData(data);
    setTableData(data);
    return;
  };

  const searchTimer = useRef(null);

  const handleSearchChange = (e) => {
    const searchValue = e.target.value;

    setSearchItem(searchValue);

    if (searchTimer.current) {
      clearTimeout(searchTimer.current);
    }

    searchTimer.current = setTimeout(() => {
      if (searchValue.length > 0) {
        searchResult(searchValue);
      } else {
        fetchStockList();
      }
    }, 500); // 500ms delay
  };

  const searchResult = async (searchValue) => {
    // console.log('searchValue in search result method',searchValue)
    if (searchValue.length < 1) {
      return;
    } else {
      setIsCallingSeachApi(true);
      const response = await axios.get(
        `${
          apiPaths_from_local_storage[0].API_CONFIG
        }/api/Search_Items/${company_code_from_local_storage}/Sitem/${encodeURIComponent(
          searchValue
        )}`
      );

      setIsCallingSeachApi(false);
      const data = response.data;
      // console.log("searchResult:>>>", data);
      setSearchResultData(data);
    }
  };

  const selectStockData = (item) => {
    console.log("selected stock item code:", item);
    setSelectedStockItem(item);
  };

  const clearSearchItem = () => {
    setSearchItem("");
    fetchStockList();
  };

  const handleTooltipToggle = (index) => {
    setOpenTooltipIndex(index);
    setTimeout(() => setOpenTooltipIndex(null), 4000);
  };

  const handleItemCodeClick = (index) => {
    setOpenItemCodeIndex(openItemCodeIndex === index ? null : index);
  };

  const handleImageUpload = (event, stockCode) => {
    const file = event.target.files[0];
    console.log("file", file);
    console.log("stockCode", stockCode);
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      console.log("imageUrl", imageUrl);
      setStockListData((prevData) =>
        prevData.map((stock) =>
          stock.Code === stockCode ? { ...stock, Imagepath: imageUrl } : stock
        )
      );
    }
  };

  // useEffect(()=>{
  //   let itemImagePath
  //   stockListData?.map((stock,index)=>stock.Imagepath !==''?stock.Imagepath= itemImagePath : '')
  //   console.log('itemImagePath:',itemImagePath)
  // },[stockListData])

  const handleOpenModal = (itemCode) => {
    setIsModalOpen(true);
    console.log("itemCode selected", itemCode);
    setSelctedImageItemCode(itemCode);
  };

  const handleOpenImageExistingModal = (itemCode, imagepath) => {
    setIsImageExistingModalOpen(true);
    console.log("itemCode selected", itemCode);
    setSelctedImageItemCode(itemCode);
    setExistingItemImage(imagepath);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsImageExistingModalOpen(false);
    setShowHideEditProductPopup(false);
    setIsModalOpenProductCreation(false);
    setSelectedImage(null);
    setPreviewImage(null);
    setCurrentItemToEdit(null);
    setObjectToSendToState(initialObjectToSendAPI);
    setItemCodeAlreadyPresentInDb(false);
  };

  // Handle image selection
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    if (file) {
      setSelectedImage(file);
      setPreviewImage(URL.createObjectURL(file)); // Preview image before upload
    }
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  // original method
  // const handleSave = async () => {
  //   if (!selectedImage) {
  //     alert("Please select an image!");
  //     return;
  //   }
  //   setIsImageExistingModalOpen(false)
  //   setIsModalOpen(false)

  //   console.log("selctedImageItemCode", selctedImageItemCode);
  //   const formData = new FormData();
  //   formData.append("UserId", selctedImageItemCode); // Replace with actual user ID

  //   let resultOfBAse64Conversion = await toBase64(selectedImage)

  //   formData.append("Description", resultOfBAse64Conversion); // Add a meaningful description // pass base64 here
  //   formData.append("Image", selectedImage);
  //   // formData.append("ImagePath", "C:\\bondtime_web_app\\BONDTIME_EMP_IMG");
  //   formData.append("ImagePath", "D:\\bondtime_web_app\\BONDTIME_PRODUCT_IMG"); // Ensure the key matches backend expectations

  //   console.log("Sending FormData...");
  //   for (let pair of formData.entries()) {
  //     console.log(pair[0] + ": ", pair[1]); // Debugging
  //   }

  //   try {
  //     const config = {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     };
  //     const response = await axios.post(
  //       "https://sunrise.dyndns-server.com:91/Posts",
  //       formData,
  //       config
  //     );

  //     setOpenSnackbar(true);
  //     fetchStockList();
  //     console.log("Upload Success:", response.data);
  //     console.log("response.data.imagepath:", response.data.imagepath);
  //   } catch (error) {
  //     console.error(
  //       "Upload Error:",
  //       error.response ? error.response.data : error.message
  //     );
  //   }
  // };

  // for manoj sir testing
  const handleSave = async () => {
    if (!selectedImage) {
      alert("Please select an image!");
      return;
    }
    setIsImageExistingModalOpen(false);
    setIsModalOpen(false);

    console.log("selctedImageItemCode", selctedImageItemCode);
    const formData = new FormData();
    formData.append("DOC_CODE", selctedImageItemCode); // Replace with actual user ID
    formData.append("DOC_TYPE", "PRODUCTIMAGE");

    formData.append(
      "IMAGEPATH",
      `${apiPaths_from_local_storage[0].IMG_SERVERPATH}\BONDTIME_PRODUCT_IMG`
    ); // here dynamically path will come from cubot api ie dependant on company and type like EMP_IMAGE , DOC_IMAGE etc path can change  // Ensure the key matches backend expectations

    let resultOfBAse64Conversion = await toBase64(selectedImage);

    formData.append("IMGBASE64", resultOfBAse64Conversion); // Add a meaningful description // pass base64 here
    formData.append("cmpcode", company_code_from_local_storage);
    formData.append("file", selectedImage);
    // formData.append("ImagePath", "C:\\bondtime_web_app\\BONDTIME_EMP_IMG");
    formData.append("description", "test");

    console.log("formdata>>> ", formData, selectedImage);
    console.log("Sending FormData...");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": ", pair[1]); // Debugging
    }

    try {
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      //earlier  "https://sunrise.dyndns-server.com:90/api/Image/upload",
      const response = await axios.post(
        `${apiPaths_from_local_storage[0].IMG_POST_PATH}/api/Image/upload`,
        formData,
        config
      );

      setOpenSnackbar(true);
      fetchStockList();
      console.log("Upload Success:", response.data);
      console.log("response.data.imagepath:", response.data.imagepath);
    } catch (error) {
      console.error(
        "Upload Error:",
        error.response ? error.response.data : error.message
      );
    }
  };

  const handleSaveImage = (stockCode, imageUrl) => {
    setStockListData((prevData) =>
      prevData.map((stock) =>
        stock.Code === stockCode ? { ...stock, Imagepath: imageUrl } : stock
      )
    );
  };

  // console.log("stockListData:", stockListData);

  const fetchItemImage = (itemFilePath) => {
    if (!itemFilePath) return "";

    // console.log("item file path:", itemFilePath);

    // Normalize Windows path
    const normalizedPath = itemFilePath.replace(/\\/g, "/");

    // Split using the known folder
    const fileName = normalizedPath.split("BONDTIME_PRODUCT_IMG/")[1];

    // console.log("extractedFileName:", fileName);

    if (!fileName) return "";

    return `${apiPaths_from_local_storage[0].IMG_API_PATH}/BONDTIME_PRODUCT_IMG/${fileName}`;
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const clickedOnShowHideModalPopup = () => {
    setIsModalOpenProductCreation((prev) => !prev);
  };

  const handleInputChangeProductCreation = (e) => {
    if (e.target.name === "code") {
      if (timerObject.current) {
        clearTimeout(timerObject.current);
      }
      timerObject.current = setTimeout(() => {
        if (e.target.value?.length != 0) {
          checkIfitemCodeExists(e.target.value);
        }
      }, 500);
    }

    setObjectToSendToState({
      ...objectToSendToState,
      [e.target.name]: e.target.value,
    });
  };

  const callProductSavingAPI = (modeFromPopup) => {
    if (itemCodeAlreadyPresentInDb) {
      alert("item code already present, please enter another one");
      return;
    }

    console.log("callProductSavingAPI ", objectToSendToState);

    if (objectToSendToState.code?.trim() === "") {
      alert("item code cannot be empty");
      return;
    }

    const code = objectToSendToState.code?.toLowerCase();

    if (!code?.endsWith("-q")) {
      alert("Please enter -Q at the end of code");
      return; // or show error, redirect, etc.
    }

    if (objectToSendToState.description?.trim() === "") {
      alert("item description cannot be empty");
      return;
    }

     

    const arrayToSendToApi = [
      {
        cmpcode: company_code_from_local_storage,
        mode: modeFromPopup,
        code: objectToSendToState.code,
        unit: objectToSendToState.unit,
        group: objectToSendToState.group,
        sgroup: objectToSendToState.sub_group,
        categ: objectToSendToState.category,
        scateg: objectToSendToState.sub_category,
        class: objectToSendToState.hscode,
        desc: objectToSendToState.description,
        location: objectToSendToState.weblink,
        store_no: objectToSendToState.origin,
        qty_open:
          (objectToSendToState.op_qty + "")?.trim() === ""
            ? "0"
            : objectToSendToState.op_qty + "",
        rcvd_ytd: "0",
        issd_ytd: "0",
        qty_rorder:
          (objectToSendToState.min_qty + "")?.trim() === ""
            ? "0"
            : objectToSendToState.min_qty + "",
        cost_unit:
          (objectToSendToState.cost_unit + "")?.trim() === ""
            ? "0"
            : objectToSendToState.cost_unit + "",
        cost_avg:
          (objectToSendToState.cost_avg + "")?.trim() === ""
            ? "0"
            : objectToSendToState.cost_avg + "",
        price_unit:
          (objectToSendToState.cash_price + "")?.trim() === ""
            ? "0"
            : objectToSendToState.cash_price + "",
        packing:
          (objectToSendToState.fixed_cost + "")?.trim() === ""
            ? "0"
            : objectToSendToState.fixed_cost + "",
        discount: "0",
        reserveqty: "0",
        po_qty: "0",
        batch: objectToSendToState.oem,
        rcvd01: "0",
        issd01: "0",
        rcvd02: "0",
        issd02: "0",
        rcvd03: "0",
        issd03: "0",
        rcvd04: "0",
        issd04: "0",
        rcvd05: "0",
        issd05: "0",
        rcvd06: "0",
        issd06: "0",
        rcvd07: "0",
        issd07: "0",
        rcvd08: "0",
        issd08: "0",
        rcvd09: "0",
        issd09: "0",
        rcvd10: "0",
        issd10: "0",
        rcvd11: "0",
        issd11: "0",
        rcvd12: "0",
        issd12: "0",
        price2:
          (objectToSendToState.credit_price + "")?.trim() === ""
            ? "0"
            : objectToSendToState.credit_price + "",
        min_qty: "0",
        max_qty: "0",
        do_pending: "0",
        cost_open:
          (objectToSendToState.cost_open + "")?.trim() === ""
            ? "0"
            : objectToSendToState.cost_open + "",
        packprice1: "0",
        fraction: "0",
        qty2_open: "0",
        qty2: "0",
        perishable: "",
        cost_fifo:
          (objectToSendToState.dcp + "")?.trim() === ""
            ? "0"
            : objectToSendToState.dcp + "",
        weight: "0",
        surf_cost: "0",
        supplier: objectToSendToState.message_2,
        dac: objectToSendToState.product_type === "inventory" ? "0" : "1",
        deptno: "", // pass user here so they can know ho entered it also on listing time show created date also so can know time
        packcost: "0",
        phy_qty: "0",
        phy_date: "",
        price3:
          (objectToSendToState.block_price + "")?.trim() === ""
            ? "0"
            : objectToSendToState.block_price + "",
        fraction2: "0",
        qtyf_open: "0",
        locaphy: "0",
        locbphy: "0",
        loccphy: "0",
        locdphy: "0",
        locephy: "0",
        locfphy: "0",
        locgphy: "0",
        exp_date: "",
        bonus: "0",
        priced:
          (objectToSendToState.spl_price + "")?.trim() === ""
            ? "0"
            : objectToSendToState.spl_price + "",
        pricee: "0",
        pricef: "0",
        priceg: "0",
        priceh: "0",
        pricei: "0",
        pricej: "0",
        gweight:
          (objectToSendToState.volume + "")?.trim() === ""
            ? "0"
            : objectToSendToState.volume + "",
        nweight:
          (objectToSendToState.weight + "")?.trim() === ""
            ? "0"
            : objectToSendToState.weight + "",
        measment: "",
        upd: "",
        lochphy: "0",
        blkitem: "",
        modelno1: objectToSendToState.model_no
          ? objectToSendToState.model_no
          : "",
        modelno2: "",
        modelno3: objectToSendToState.class,
        LPCOST: "0",
        LSPRICE: "0",
        desc1: objectToSendToState.specification,
        desc2: objectToSendToState.message,
        active: "",
        VOLACTIVE: "",
        SPRICETYPE: "",
        SP: "0",
        priceK: "0",
        priceL: "0",
        priceM: "0",
        priceN: "0",
        priceO: "0",
        priceP: "0",
        priceQ: "0",
        priceR: "0",
        priceS: "0",
        priceT: "0",
        priceU: "0",
        priceV: "0",
        priceW: "0",
        priceX: "0",
        priceY: "0",
      },
    ];

    console.log("arrayToSendToApi>>", arrayToSendToApi);
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/productreg`;

    axios
      .post(apiUrl, arrayToSendToApi)
      .then((res) => {
        if (res.data.result === "Saved") {
          if (modeFromPopup === "EDIT") {
            alert("Product edited successfully");
            setSearchItem("");
            fetchStockList();
            setCurrentItemToEdit(null);
            setShowHideEditProductPopup((prev) => !prev);
          } else {
            alert("Product added successfully");
          }

          setIsModalOpenProductCreation(false);
          setObjectToSendToState(initialObjectToSendAPI);
        } else {
          alert("Something went wrong");
        }
      })
      .catch((err) => {
        alert("Something went wrong");
      });
  };

  const checkIfitemCodeExists = async (valueFromText) => {
    let url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/viewitem/${valueFromText}`;

    axios.get(url).then((res) => {

      setDuplicateItemCodeArray(res.data)
      if (res.data.length === 0) {
        setItemCodeAlreadyPresentInDb(false);
      } else {
        setItemCodeAlreadyPresentInDb(true);
      }
    });
  };

  const getItemDetailsToEdit = (valueFromText) => {
    let url = `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/viewitem/${valueFromText}`;

    console.log("getItemDetailsToEdit", url);

    axios.get(url).then((res) => {
      if (res.data.length != 0) {
        let editObject = res.data[0];

        let editObjectDetails = {
          code: editObject.code,
          oem: editObject.batch,
          model_no: editObject.model_no,
          description: editObject.desc,
          specification: editObject.desc1,
          group: editObject.group,
          sub_group: editObject.sgroup,
          category: editObject.categ,
          sub_category: editObject.scateg,
          volume: editObject.gweight,
          weight: editObject.nweight,
          hscode: editObject.class,
          origin: editObject.store_no,
          class: editObject.modelno3,
          unit: editObject.unit,
          weblink: editObject.location,
          op_qty: editObject.qty_open,
          bal_qty: "",
          cash_price: editObject.price_unit,
          credit_price: editObject.price2,
          spl_price: editObject.priced,
          block_price: editObject.price3,
          cost_open: editObject.cost_open,
          cost_unit: "0",
          cost_avg: "0",
          last_pcost: "",
          dcp: editObject.cost_fifo,
          min_qty: editObject.qty_rorder,
          reorder_qty: "0",
          fixed_cost: editObject.packing,
          message: editObject.desc2,
          message_2: editObject.supplier,
          product_type: editObject.dac === "0" ? "inventory" : "service", // or service
          location: "",
          store_no: "",
        };
        setObjectToSendToState(editObjectDetails);
      }
    });
  };

  useEffect(() => {
    console.log("currentItemtoedit ", currentItemToEdit);

    if (currentItemToEdit) {
      getItemDetailsToEdit(currentItemToEdit);
    }
  }, [currentItemToEdit]);

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const sortedTableData = React.useMemo(() => {
    if (!tableData || !sortConfig.key) return tableData;
    return [...tableData].sort((a, b) => {
      const aVal = a[sortConfig.key] ?? "";
      const bVal = b[sortConfig.key] ?? "";
      // numeric sort for number-like values
      if (!isNaN(aVal) && !isNaN(bVal)) {
        return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
      }
      // string sort
      return sortConfig.direction === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    });
  }, [tableData, sortConfig]);

  return (
    <div className="py-4 px-1 rounded-lg mx-2">
      <div className="flex items-center gap-20">
        <h3 className="text-lg">StockList</h3>

        <div className="bg-grey-100">
          <div className="relative">
            <input
              type="text"
              value={searchItem}
              onChange={handleSearchChange}
              placeholder="Search StockList …"
              className="w-full py-2 pl-10 pr-4 rounded-lg bg-white text-black placeholder-gray-400 border border-none shadow"
            />
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <AiOutlineSearch className="text-gray-500" />
            </div>
            {searchItem && (
              <div
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                onClick={clearSearchItem} // Clear the search term when clicked
              >
                <AiOutlineClose className="text-gray-500" />
              </div>
            )}

            {/* {searchResultData &&
              showDropdown &&
              searchItem?.length > 0 && (
                <div className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300">
                  {console.log("searchResultData:", searchResultData)}
                  {searchResultData?.map((stock, index) => (
                      <div
                        onClick={() => {
                          selectStockData(stock.Code);
                          setShowDropdown(false);
                        }}
                        key={index}
                        className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                      >
                        <p className="font-normal text-xs">{stock.Code}</p>
                        <p className="font-normal text-xs">{stock.Description}</p>
                      </div>
                    ))}
                </div>
              )}  */}
          </div>
        </div>

        <h2 className="text-lg font-normal my-4">
          {/* Top {stockListData?.length} Items */}
          {/* Top {searchResultData?.length} Items */}
          Top {tableData?.length} Items
        </h2>

        <button
          onClick={() => clickedOnShowHideModalPopup()}
          class="block text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
        >
          Add product
        </button>
      </div>

      {isCallingSeachApi && (
        <div style={{ display: "flex" }}>
          <div role="status">
            <svg
              aria-hidden="true"
              class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
          <text className="ms-2">Searching</text>
        </div>
      )}
      <div></div>

      {loadingitems && (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      )}
      <div className="mt-6 max-w-[91vw] overflow-x-auto  scrollbar-thin">
        {tableData?.length > 0 ? (
          <div className="flex items-center gap-2 ">
            <div className="max-h-[65vh] w-full ">
              <table className=" border border-gray-300 bg-white shadow-md  min-w-max">
              <thead className="bg-gray-100 border-b sticky top-0 z-20">
  <tr>
    {[
      { label: "Code",         key: "Code"        },
      { label: "Image",        key: null           }, // not sortable
      { label: "Description",  key: "Description"  },
      { label: "Stock",        key: "Stock"        },
      { label: "Price",        key: "SelPrice"     },
      { label: "ORD_PEND",     key: "Ord_Pend"     },
      { label: "PO_PEND",      key: "Po_Pend"      },
      { label: "Category",     key: "Category"     },
      { label: "Sub Category", key: "SubCatetory"  },
      { label: "Group",        key: "Group"        },
      { label: "S Group",      key: "Sgroup"       },
      { label: "Bin",          key: "BIN"          },
    ].map(({ label, key }) => (
      <th
        key={label}
        onClick={() => key && handleSort(key)}
        className={`px-1 py-0.5 text-sm text-left font-normal select-none
          ${key ? "cursor-pointer hover:bg-gray-200" : ""}
          ${label === "Code" ? "w-[120px] bg-gray-100 sticky left-0 z-10" : ""}
        `}
      >
        {label}
        {key && (
          <span className="ml-1 text-gray-400">
            {sortConfig.key === key
              ? sortConfig.direction === "asc" ? "▲" : "▼"
              : "⇅"}
          </span>
        )}
      </th>
    ))}
  </tr>
</thead>
                <tbody>
                  {/* {stockListData?.map((stock, index) => ( */}
                  {/* {searchResultData?.map((stock, index) => ( */}
                  {tableData?.map((stock, index) => (
                    <tr key={index} className="border-b hover:bg-gray-50 ">
                      <div className="">
                        <td className="w-[220px] px-1 py-2 text-base bg-white sticky left-0 z-10 cursor-pointer flex items-center justify-between hover:bg-gray-50">
                          <span
                            onClick={() => {
                              setShowHideEditProductPopup((prev) => !prev);
                              setCurrentItemToEdit(stock.Code);
                            }}
                          >
                            {stock.Code}{" "}
                            <button>
                              <CiEdit />
                            </button>
                          </span>

                          <span className="flex">
                            <button
                              onClick={() =>
                                setOpenItemCodeIndex(
                                  openItemCodeIndex === index ? null : index
                                )
                              }
                              className="ml-2 text-gray-600 hover:text-gray-900"
                            >
                              {openItemCodeIndex === index ? "−" : "+"}
                            </button>
                          </span>
                        </td>
                        
                        {openItemCodeIndex === index && (
                          <td colSpan="120" className="p-2 bg-gray-50">
                            <div className="grid grid-cols-1 gap-2">
                              <div>Stock: {stock.Stock || 0}</div>
                              <div>Price: {stock.SelPrice || 0}</div>
                              <div>ORD_PEND: {stock.Ord_Pend || "N/A"}</div>
                              <div>PO_PEND: {stock.Po_Pend || "N/A"}</div>
                              <div>
                                Subcategory: {stock.SubCatetory || "N/A"}
                              </div>
                              <div>Group: {stock.Group || "N/A"}</div>
                              <div>S Group: {stock.Sgroup || "N/A"}</div>
                              <div>Bin: {stock.BIN || "N/A"}</div>
                            </div>
                          </td>
                        )}
                      </div>

                      {/* <td className="px-1 py-0.5 text-sm width-[100px]">
                        <span className="text-center">
                          {console.log('stock.Imagepath',stock.Imagepath)}
                          {stock.Imagepath !== "" ? (
                            <img
                              src={ImageIcon}
                              alt="Image Icon"
                              className="w-8 h-8"
                            />
                          ) : (
                            <div className="relative cursor-pointer">
                            <input
                              type="file"
                              accept="image/*"
                              className="absolute inset-0 opacity-0 cursor-pointer"
                              onChange={(event) => handleImageUpload(event, stock.CODE)}
                            />
                            {stock.Imagepath ? (
                              <img
                                src={stock.Imagepath}
                                alt="Uploaded Image"
                                className="w-12 h-12 object-cover border rounded-md"
                              />
                            ) : (
                              <img
                                src={notAllowedSymbol} // Default icon if no image is uploaded
                                alt="Not Allowed"
                                className="w-6 h-6 object-cover border rounded-md"
                              />
                            )}
                          </div>

                          )}
                        </span>
                      </td> */}

                      <td>
                        <div className="relative cursor-pointer">
                          {stock.Imagepath ? (
                            <img
                              onClick={() =>
                                handleOpenImageExistingModal(
                                  stock.Code,
                                  stock.Imagepath
                                )
                              }
                              src={fetchItemImage(stock.Imagepath)}
                              alt="Upload"
                              className="w-20 h-20 object-cover border rounded-md"
                            />
                          ) : (
                            // <img
                            //   onClick={() => handleOpenModal(stock.Code)}
                            //   src={
                            //     notAllowedSymbol
                            //   }
                            //   alt="Upload"
                            //   className="w-16 h-16 object-cover border rounded-md"
                            // />
                            <span
                              alt="Upload"
                              onClick={() => handleOpenModal(stock.Code)}
                              style={{
                                backgroundColor: "#f7f7f7",
                                borderWidth: "1px",
                                borderRadius: "4px",
                                width: "80px",
                                height: "60px",
                                display: "block",
                              }}
                            />
                          )}
                        </div>
                      </td>

                      <Tooltip
                        title={stock.Description}
                        arrow
                        open={openTooltipIndex === index}
                        onClose={() => setOpenTooltipIndex(false)}
                      >
                        <td
                          onClick={() => handleTooltipToggle(index)}
                          className="px-1 py-0.5 text-sm max-w-[400px]  overflow-hidden text-ellipsis whitespace-nowrap cursor-pointer"
                        >
                          {stock.Description}
                        </td>
                      </Tooltip>
                      <td className="px-1 py-0.5 text-sm ">
                        {stock.Stock || 0}
                      </td>
                      <td className="px-1 py-0.5 text-sm ">
                        {stock.SelPrice || 0}
                      </td>
                      {/* <td className="px-1 py-0.5 text-sm">
                        {stock.BRAND || "N/A"}
                      </td> */}
                        <td className="px-1 py-0.5 text-sm">
                        {stock.Ord_Pend || "N/A"}
                      </td>
                      <td className="px-1 py-0.5 text-sm">
                        {stock.Po_Pend || "N/A"}
                      </td>

                      <td className="px-1 py-0.5 text-sm">
                        {stock.Category || "N/A"}
                      </td>
                      <td className="px-1 py-0.5 text-sm">
                        {stock.SubCategory || "N/A"}
                      </td>

                      <td className="px-1 py-0.5 text-sm">
                        {stock.Group || "N/A"}
                      </td>
                      <td className="px-1 py-0.5 text-sm">
                        {stock.Sgroup || "N/A"}
                      </td>
                      <td className="px-1 py-0.5 text-sm">
                        {stock.BIN || "N/A"}
                      </td>
                    
                      {/* <td className="px-1 py-0.5 text-sm">{stock.PO_PEND  || "N/A"}</td>
            <td className="px-1 py-0.5 text-sm">{stock.PO_PEND  || "N/A"}</td>
            <td className="px-1 py-0.5 text-sm">{stock.PO_PEND  || "N/A"}</td>
            <td className="px-1 py-0.5 text-sm">{stock.PO_PEND  || "N/A"}</td>
            <td className="px-1 py-0.5 text-sm">{stock.PO_PEND  || "N/A"}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* <h2 className="text-lg font-normal mb-4">
    selected stock Items : {selectedStockItem} 
  </h2> */}
          </div>
        ) : (
          <div
            className="h-screen flex justify-center  bg-gray-2000"
            style={{ backgroundColor: "#f8f8f8" }}
          >
            <p className="text-center text-gray-500 my-12">
              {/* <h2 className="bg-red-600 text-white px-6 py-2 width-full rounded-t-md">Lost Leads</h2> */}
              <div className="flex flex-col justify-center items-center text-gray-500 bg-transparent rounded-b-md p-10 ">
                <img src={emptyList} alt="emptylist" className="w-52 h-42" />
                <p className="text-gray-400 pb-2 text-center">
                  Search Item Not Available!
                </p>
              </div>
            </p>
          </div>
        )}
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-semibold mb-4">Upload Image</h2>

            {/* File Input */}
            <input type="file" accept="image/*" onChange={handleImageChange} />

            {/* Image Preview */}
            {previewImage && (
              <div className="mt-4">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="w-32 h-32 object-cover border rounded-md"
                />
              </div>
            )}

            <div className="flex justify-end mt-4">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-gray-500 text-white rounded-md mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isImageExistingModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            {/* {console.log("existingItemImage:", existingItemImage)}
            {console.log(
              "existingItemImage2:",
              fetchItemImage(existingItemImage),
            )} */}
            <div className="mt-4">
              <img
                src={fetchItemImage(existingItemImage)}
                alt="Preview"
                className="w-52 h-52 object-cover border rounded-md"
              />
            </div>

            <h2 className="text-lg font-semibold mb-4">Update Image</h2>

            {/* File Input */}
            <input type="file" accept="image/*" onChange={handleImageChange} />

            {/* Image Preview */}
            {previewImage && (
              <div className="mt-4">
                <img
                  src={previewImage}
                  alt="Preview"
                  className="w-32 h-32 object-cover border rounded-md"
                />
                <h2 className="text-lg font-semibold mb-4">New Image</h2>
              </div>
            )}

            <div className="flex justify-end mt-4">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 bg-gray-500 text-white rounded-md mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-500 text-white rounded-md"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {`Item Image Uploaded Succesfully `}
        </MuiAlert>
      </Snackbar>

      {isModalOpenProductCreation && (
        <div
          style={{
            backgroundColor: "#00000080",
            padding: "20px",
            position: "fixed",
            top: "0px",
            left: "0px",
            width: "100vw",
            height: "100vh",
            zIndex: 100,
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              height: "90%",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "60px",
                display: "flex",
                padding: "10px",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f7f7f7",
              }}
            >
              <div>
                <h2 style={{ fontSize: "20px" }}>Add product</h2>
              </div>
              <button
                onClick={() => clickedOnShowHideModalPopup()}
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                X
              </button>
            </div>

            <div
              style={{
                overflowY: "scroll",
                height: "calc(100% - 130px)",
                padding: "10px",
              }}
            >
              <ProductCreationForm
                mode="add"
                handleInputChangeProductCreation={
                  handleInputChangeProductCreation
                }
                objectToSendToState={objectToSendToState}
                groupList={groupList}
                subgroupList={subGroupList}
                categoryList={categoryList}
                subCategoryList={subCategoryList}
                unitList={unitList}
                itemCodeAlreadyPresentInDb={itemCodeAlreadyPresentInDb}
                duplicateItemCodeArray = {duplicateItemCodeArray}
              />
            </div>

            <div
              style={{
                height: "70px",
                position: "absolute",
                width: "100%",
                padding: "10px",
                bottom: "0px",
                display: "flex",
                justifyContent: "end",
                backgroundColor: "#f7f7f7",
              }}
            >
              <button
                className="text-white bg-gray-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2  focus:outline-none dark:focus:ring-blue-800"
                onClick={() => clickedOnShowHideModalPopup()}
              >
                Cancel
              </button>
              <button
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                onClick={() => callProductSavingAPI("ENTRY")}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {showHideEditProductPopup && (
        <div
          style={{
            backgroundColor: "#00000080",
            padding: "20px",
            position: "fixed",
            top: "0px",
            left: "0px",
            width: "100vw",
            height: "100vh",
            zIndex: 100,
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              height: "90%",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "60px",
                display: "flex",
                padding: "10px",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#f7f7f7",
              }}
            >
              <div>
                <h2 style={{ fontSize: "20px" }}>Edit product</h2>
              </div>
              <button
                onClick={() => setShowHideEditProductPopup((prev) => !prev)}
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
              >
                X
              </button>
            </div>

            <div
              style={{
                overflowY: "scroll",
                height: "calc(100% - 130px)",
                padding: "10px",
              }}
            >
              <ProductCreationForm
                mode="edit"
                handleInputChangeProductCreation={
                  handleInputChangeProductCreation
                }
                objectToSendToState={objectToSendToState}
                groupList={groupList}
                subgroupList={subGroupList}
                categoryList={categoryList}
                subCategoryList={subCategoryList}
                unitList={unitList}
                itemCodeAlreadyPresentInDb={itemCodeAlreadyPresentInDb}
              />
            </div>

            <div
              style={{
                height: "70px",
                position: "absolute",
                width: "100%",
                padding: "10px",
                bottom: "0px",
                display: "flex",
                justifyContent: "end",
                backgroundColor: "#f7f7f7",
              }}
            >
              <button
                className="text-white bg-gray-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2  focus:outline-none dark:focus:ring-blue-800"
                onClick={() => setShowHideEditProductPopup((prev) => !prev)}
              >
                Cancel
              </button>
              <button
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                onClick={() => callProductSavingAPI("EDIT")}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StockList;
